import { render, staticRenderFns } from "./AppHelpPage.vue?vue&type=template&id=b261f34c&scoped=true&"
import script from "./AppHelpPage.vue?vue&type=script&lang=js&"
export * from "./AppHelpPage.vue?vue&type=script&lang=js&"
import style0 from "./AppHelpPage.vue?vue&type=style&index=0&id=b261f34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b261f34c",
  null
  
)

export default component.exports